import { Unit } from "../../isq/isq.js";
import { Codecs } from "../types.js";
import { BaseCodec } from "./base-codec.js";
export class LevelCodec extends BaseCodec {
    static get = (definition) => {
        return new LevelCodec(definition?.base);
    };
    base;
    constructor(base) {
        super();
        this.base = base !== undefined ? base : Unit.LEVEL_BASE_10;
    }
    setUnit(unit) {
        //units cannot be changed (yet)
        return this;
    }
    encode(decodedValue) {
        return [decodedValue != null ? Math.pow(this.base, decodedValue) : null];
    }
    _decode(encodedValue) {
        return Math.log10(encodedValue) / Math.log10(this.base);
    }
    getDefinition() {
        return {
            id: Codecs.LEVEL,
            base: this.base
        };
    }
    toString() {
        return JSON.stringify(this.getDefinition());
    }
}
